<template>
  <transition name="slide-down">
    <main v-if="show_banner" class="reset-wapp-qr-banner">
      <section class="content-banner">
        <figure>
          <img :src="qrCodeUrl" alt="qr-code">
        </figure>
        <div class="content-message">
          <h4>Scaneaza codul QR pentru WhatsApp</h4>
          <p>Conecteazǎ-te rapid şi sigur!</p>
        </div>
      </section>
    </main>
  </transition>
</template>

<script>
  import {svg} from "@/store/svg";

  export default {
    name: "Reset_Wapp_QR_Banner",
    computed: {
      svg() {
        return svg
      },
      qrCodeUrl () {
        return `https://dinstituteapp.ro/calendar/qr?ts=${this.$store.state.qrRefreshKey}`;
      }
    },
    data() {
      return {
        qrRefreshKey: Date.now(),
        show_banner: false,
      }
    },
    methods: {
      refreshQr() {
        this.qrRefreshKey = Date.now()
      }
    },
    mounted() {
      setTimeout(() => {
        this.show_banner = true
      }, 100)
    }
  }
</script>

<style lang="less">
  .reset-wapp-qr-banner {
    @media only screen and (min-width: 0) {
      position: fixed;
      top: 0;
      left: 0;
      padding: 10px 240px;
      width: 100%;
      height: 150px;
      background-color: rgba(68, 194, 169, 0.75);
      backdrop-filter: blur(10px);
      z-index: 999;
      > section {
        display: flex;
        align-items: center;
        figure {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 120px;
          height: 120px;
          background-color: rgba(white, 0.3);
          border-radius: 10px;
          img {
            width: 100px;
            height: 100px;
          }
        }

        .content-message {
            margin: 15px 0 35px 15px;
            h4{
              font-size: 18px;
              color: white;
              font-weight: bold;
            }
            p {
              margin-top: 7px;
              color: rgba(255, 255, 255, 0.93);
              font-size: 16px;
              font-weight: 400;
            }
        }
      }
    }
  }

  .slide-down-enter-active {
    transition: all 0.5s ease-out;
  }

  .slide-down-enter {
    transform: translateY(-100%);
    opacity: 0;
  }

  .slide-down-enter-to {
    transform: translateY(0);
    opacity: 1;
  }
</style>
